import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-downdisable",
  "use": "icon-downdisable-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-downdisable\"><path d=\"M511.999488 819.413462 72.8374 204.586538 951.1626 204.586538Z\" p-id=\"1438\" fill=\"#CCCCCC\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol